import {
  configApp as AdonisConfigApp,
  RULES_LIST as AdonisRulesList,
  PLUGINS_LIST as AdonisPluginsList,
  // @ts-expect-error
} from '@adonisjs/eslint-config'

import type { TSESLint } from '@typescript-eslint/utils'
import type { FlatConfig, Linter } from '@typescript-eslint/utils/ts-eslint'

interface AdonisConfigAppFn {
  (...configBlocksToMerge: FlatConfig.Config[]): TSESLint.FlatConfig.ConfigArray
}

/**
 * Configures ESLint to use an opinionated config tailored for NHT Development
 */
export const configApp: AdonisConfigAppFn = AdonisConfigApp as AdonisConfigAppFn

type AdonisRuleConfig = Partial<Linter.RulesRecord>

/**
 * Default list of rules to apply
 */
export const RULES_LIST: AdonisRuleConfig = AdonisRulesList as AdonisRuleConfig

interface AdonisPluginsList {
  [pluginName: string]: FlatConfig.Plugin
}

/**
 * Default list of plugins to apply
 */
export const PLUGINS_LIST: AdonisPluginsList = AdonisPluginsList as AdonisPluginsList
